import { render, staticRenderFns } from "./productConfig.vue?vue&type=template&id=6049fc2d&scoped=true"
import script from "./productConfig.vue?vue&type=script&lang=js"
export * from "./productConfig.vue?vue&type=script&lang=js"
import style0 from "./productConfig.vue?vue&type=style&index=0&id=6049fc2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6049fc2d",
  null
  
)

export default component.exports